export const inlineStyles = {
    axisScaleLine: {
        stroke: '#cad7e1',
    },
};
